import { CompanyList } from "../../../features/Company/CompanyList";
import { Footer } from "../../../features/footer/footer";

export function CompanyListPage() {

    return (
        <div>
            <CompanyList />
            <Footer />
        </div>
    );
}